// extracted by mini-css-extract-plugin
export default {"content":"BusinessStaffList_content__iKTxu","actions":"BusinessStaffList_actions__A0E8t","selected":"BusinessStaffList_selected__LjY9t"};